

angular.module('admin')
.controller('FileUploadCtrl', function (FileUploader, $cookies, $timeout, ListController, AdditionalFormData) {
	var uploader = this.uploader = new FileUploader({
        url: ListController.Class.get_url('upload'),
        autoUpload: true,
        removeAfterUpload: true,
        headers: {'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN')},
        formData: [{x:1}]
    });

	var self = this;
	this.current_item = null;
	this.current_item_error = '';

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
        console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function(fileItem) {
    	console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function(addedFileItems) {
        console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function(item) {
        console.info('onBeforeUploadItem', item);
        self.current_item = item;
        self.current_item_error = '';
        //item.formData.push({parent_vid: $scope.object.__vid});
        item.formData.push(AdditionalFormData);
    };
    uploader.onProgressItem = function(fileItem, progress) {
        console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function(progress) {
        console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function(fileItem, response, status, headers) {
        console.info('onSuccessItem', fileItem, response, status, headers);
        ListController.reload();
    };
    uploader.onErrorItem = function(fileItem, response, status, headers) {
        console.info('onErrorItem', fileItem, response, status, headers);
        var message = response.message || 'unknown reason';
        try {
        	var message = JSON.decode(response).message;
        } catch (e) {}
        self.current_item_error = 'Error (' + status + '): ' + message;
    };
    uploader.onCancelItem = function(fileItem, response, status, headers) {
        console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function(fileItem, response, status, headers) {
        console.info('onCompleteItem', fileItem, response, status, headers);
    };
    uploader.onCompleteAll = function() {
        console.info('onCompleteAll');
        $timeout(function(){
        	if (self.current_item.isSuccess) self.current_item = null;
        }, 2000);
    };

    console.info('uploader', uploader);
    
    window.$fileupload = self;
});




